export type Theme = "light" | "dark" | "system";

export const THEME_COOKIE_NAME = "theme";
export const DEFAULT_THEME: Theme = "system";
